import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'portfolio/ae_dreams_mockup.jpg' satisfies MediaPath
const pair = 'portfolio/ae_dreams_mockup3.jpg' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'dreams',
	name: "Einstein's Dreams",
	excerpt: 'Book design for Alan Lightman’s novel',
	tags: ['design', 'editorial'],
	cover,
	order: 55,
}

export default function Dreams() {
	return (
		<>
			<h2 className="font-bold text-xl mt-0">Overview</h2>
			<p>
				A cover and case design for Alan Lightman’s <em>Einstein’s Dreams</em> — a novel of time
				imagined many ways. The jacket renders a portrait of Einstein dissolving into a field of
				dots and faint circuitry, so the figure only coheres at a distance.
			</p>
			<p>
				Type is set quiet and classical against the noise; the spine and back carry the same dot
				system into a darker, sparser key.
			</p>
			<Gallery
				cols={2}
				items={[
					{ src: cover, alt: 'Einstein’s Dreams — cover and case' },
					{ src: pair, alt: 'Front and back, paired' },
				]}
			/>
		</>
	)
}
